import { getUser } from 'services/local/auth';
import { DEFAULT_ITEMS } from 'constants/customerMetricsOrder';
import type { LocalStorageFunctions, LocalCustomerMetricsOrder } from './types';

const CUSTOMER_METRICS_ORDER: string = 'customer-metrics-order';

const getLocalStorageCustomerMetricsOrder = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return DEFAULT_ITEMS;
  const choice = fn.readObject<Record<string, string[]>>(CUSTOMER_METRICS_ORDER);
  if (!choice?.[user.user.email]) return DEFAULT_ITEMS;
  return choice[user.user.email];
};

const setLocalStorageCustomerMetricsOrder = (fn: LocalStorageFunctions) => (data: string[]) => {
  const user = getUser(fn)();
  if (!user) return;
  let choice = fn.readObject<Record<string, string[]>>(CUSTOMER_METRICS_ORDER);
  if (!choice) {
    choice = {};
  }
  choice[user.user.email] = data;
  fn.writeObject(CUSTOMER_METRICS_ORDER, choice);
};

const delLocalStorageCustomerMetricsOrder = (fn: LocalStorageFunctions) => () => {
  const user = getUser(fn)();
  if (!user) return;
  const choice = fn.readObject<Record<string, string[]>>(CUSTOMER_METRICS_ORDER);
  if (!choice?.[user.user.email]) return;
  delete choice[user.user.email];
  fn.writeObject(CUSTOMER_METRICS_ORDER, choice);
};

const customerMetricsOrder = (fn: LocalStorageFunctions): LocalCustomerMetricsOrder => ({
  getLocalStorageCustomerMetricsOrder: getLocalStorageCustomerMetricsOrder(fn),
  setLocalStorageCustomerMetricsOrder: setLocalStorageCustomerMetricsOrder(fn),
  delLocalStorageCustomerMetricsOrder: delLocalStorageCustomerMetricsOrder(fn)
});

export default customerMetricsOrder;
